import {forwardRef, TdHTMLAttributes} from 'react';

export type TableStaticCellProps = TdHTMLAttributes<HTMLTableDataCellElement>;
const TableStaticCell = forwardRef<HTMLTableCellElement, TableStaticCellProps>(
    (props, ref) => <td ref={ref} {...props} />,
);
TableStaticCell.displayName = 'TableStaticCell';

export default TableStaticCell;
